export default __webpack_public_path__ + "static/media/download.964ca01c.svg";